class ShopTheLookVersionTwo extends HTMLElement {
  connectedCallback() {
    this.addActiveClassToSummary();
  }

  addActiveClassToSummary() {
    const detailsElements = this.querySelectorAll('details');

    detailsElements.forEach((details) => {
      const summary = details.querySelector('summary');
      const listItem = details.closest('li[data-element]');

      if (!summary || !listItem) return;

      details.addEventListener('toggle', () => {
        if (details.open) {
          const activeElements = this.querySelectorAll('li.active');

          activeElements.forEach((li) => li.classList.remove('active'));

          listItem.classList.add('active');
        } else {
          listItem.classList.remove('active');
        }
      });
    });
  }
}

customElements.define('shop-the-look-v2', ShopTheLookVersionTwo);
